import { render, staticRenderFns } from "./QTL.vue?vue&type=template&id=36c541c0&"
import script from "./QTL.vue?vue&type=script&lang=js&"
export * from "./QTL.vue?vue&type=script&lang=js&"
import style0 from "./QTL.vue?vue&type=style&index=0&id=36c541c0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports